import React from "react";

const lateSteps = ["Emerging financial stress", "Delinquency", "Escalation", "Loss mitigation", "Foreclosure", "Property / REO disposition"];
const goodSteps = ["Emerging financial stress", "Earlier identification", "Structured review", "Appropriate options evaluated", "Approved intervention", "Outcome monitored"];

const Arrows = ({ steps, klass }) => (
  <>
    {steps.map((s, i) => (
      <React.Fragment key={i}>
        <div className="flow-step">{s}</div>
        {i < steps.length - 1 && <div className="flow-arrow">↓</div>}
      </React.Fragment>
    ))}
  </>
);

const EconomicSection = () => (
  <>
    <section className="section bg2">
      <div className="wm">
        <div className="ws">
          <div className="eyebrow">The Economic Rationale</div>
          <h2 className="h2">A Foreclosure Can Turn a Servicing Relationship Into a <em className="red">Recovery Process.</em></h2>
          <p className="lead">When a mortgage progresses into foreclosure, the institution may move from managing a long-term borrower relationship into managing a legal, operational, property, and disposition process.</p>
          <p className="lead">That can involve legal and procedural expenses, servicing advances, property preservation, taxes, insurance, REO carrying costs, liquidation risk, operational resources, and loss of ongoing servicing economics.</p>
          <p className="lead">When an appropriate and approved resolution can keep the borrower in the home and the mortgage relationship active, the institution may have an opportunity to preserve payment cash flow, servicing continuity, borrower relationship value, and time to resolve the underlying issue. The Playbook is designed to help institutions identify those opportunities earlier.</p>
        </div>
        <div className="anchor-statement">
          <p>The objective is not <strong>“foreclosure prevention at any cost.”</strong> The objective is earlier identification of borrowers for whom an appropriate, approved resolution may still be possible.</p>
        </div>
      </div>
    </section>

    <section className="section bg1">
      <div className="wm">
        <div className="eyebrow">Two Operating Paths</div>
        <h2 className="h2">From Late-Stage Recovery to <em className="green">Earlier Governed Engagement</em></h2>
        <div className="flow-compare">
          <div className="flow-col late">
            <h4>Traditional Late-Stage Process</h4>
            <Arrows steps={lateSteps} />
          </div>
          <div className="flow-col good">
            <h4>Earlier Governed Engagement</h4>
            <Arrows steps={goodSteps} />
          </div>
        </div>
        <p className="md-note">The Playbook is designed to help institutions identify and evaluate opportunities before a temporary problem becomes a later-stage recovery event. It does not claim that earlier engagement will always prevent foreclosure — outcomes depend on borrower circumstances, investor requirements, and institutional decisions.</p>
      </div>
    </section>
  </>
);

export default EconomicSection;
